import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { format } from "date-fns";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class UpdateRequestDateHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method === 'POST' || req.method === 'PUT') {
      this.localDate2IsoString(req.body);
    }
    return next.handle(req);
  }

  localDate2IsoString(body) {
    if (body === null || body === undefined) {
      return body;
    }

    if (typeof body !== 'object') {
      return body;
    }

    for (const key of Object.keys(body)) {
      const value = body[key];
      if (value instanceof Date) {
         body[key] = format(value, "yyyy-MM-dd'T'HH:mm:ss");
      } else if (typeof value === 'object') {
          this.localDate2IsoString(value);
      }
    }
  }
}
